export const updateLogDeliveryLittle = (log) => ({
  type: "UPDATE_LOG_DELIVERY_LITTLE",
  payload: log,
});

export const pushBeforeLogDeliveryLittle = (log) => ({
  type: "PUSH_BEFORE_LOG_DELIVERY_LITTLE",
  payload: log,
});
